// Public capability claims for the Integrations page.
//
// Keep this file free of JSX so the contract can be checked directly in Node.
// A provider logo is presentation only: it is not an availability claim unless
// the provider has an entry in LIMITED_CAPABILITIES.

export const LIMITED_CAPABILITIES = {
  Asana: { id: 'asana', mode: 'oauth', evidence: ['ScopeWorth.App/apps/api/src/connectors/asana'] },
  Jira: { id: 'jira', mode: 'oauth', evidence: ['ScopeWorth.App/apps/api/src/connectors/jira', 'ScopeWorth.App/apps/worker/src/registry.ts'] },
  GitHub: { id: 'github', mode: 'github-app', evidence: ['ScopeWorth.App/docs/github-connector.md'] },
  GitLab: { id: 'gitlab', mode: 'oauth', evidence: ['ScopeWorth.App/apps/api/src/connectors/gitlab'] },
  Linear: { id: 'linear', mode: 'oauth', evidence: ['ScopeWorth.App/apps/api/src/connectors/linear'] },
  'Google Calendar': { id: 'google-calendar', mode: 'oauth', evidence: ['ScopeWorth.App/apps/api/src/connectors/google-calendar'] },
  'Microsoft 365 Calendar': { id: 'microsoft-365-calendar', mode: 'oauth', aliases: ['Microsoft 365'], evidence: ['ScopeWorth.App/apps/api/src/connectors/microsoft-365'] },
  Slack: { id: 'slack', mode: 'oauth', evidence: ['ScopeWorth.App/docs/communication-connectors.md'] },
  'Microsoft Teams': { id: 'microsoft-teams', mode: 'oauth', evidence: ['ScopeWorth.App/docs/communication-connectors.md'] },
  'Azure DevOps': { id: 'azure-devops', mode: 'oauth-or-credential', evidence: ['ScopeWorth.App/apps/api/src/connectors/azure-devops'] },
  Bitbucket: { id: 'bitbucket', mode: 'oauth', evidence: ['ScopeWorth.App/apps/api/src/connectors/bitbucket'] },
  'GitHub Copilot': { id: 'github-copilot', mode: 'token', evidence: ['ScopeWorth.App/docs/ai-vendor-feeds.md'] },
  Cursor: { id: 'cursor', mode: 'token', evidence: ['ScopeWorth.App/docs/ai-vendor-feeds.md'] },
  'Claude Code': { id: 'claude-code', mode: 'token', evidence: ['ScopeWorth.App/docs/ai-vendor-feeds.md'] },
  AWS: { id: 'aws', mode: 'role-grant', evidence: ['ScopeWorth.App/docs/cloud-cost-connectors.md'] },
  'Microsoft Azure': { id: 'microsoft-azure', mode: 'role-grant', evidence: ['ScopeWorth.App/docs/cloud-cost-connectors.md'] },
  'Google Cloud': { id: 'google-cloud', mode: 'role-grant', evidence: ['ScopeWorth.App/docs/cloud-cost-connectors.md'] },
};

export const IMPORT_CAPABILITY_IDS = [
  'rate-cards',
  'time-entries',
  'invoices',
  'cloud-cost-lines',
  'delivery-evidence',
  'budgets',
];

export const ALLOWED_CONNECTION_MODES = [
  'oauth',
  'github-app',
  'oauth-or-credential',
  'token',
  'role-grant',
];
